exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".dimmed.dimmable > .ui.animating.dimmer,\n.dimmed.dimmable > .ui.visible.dimmer,\n.ui.active.dimmer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.ui.modal,\n.ui.active.modal {\n  transition: all ease 0.5s;\n}\n.modal-header {\n  color: #4b8bb1 !important;\n  font-size: 15px !important;\n}\n.modal-content {\n  background-color: #ffffff !important;\n}\n.modal-action {\n  padding: 10px !important;\n}\n.ui.dimmer {\n  z-index: 9999 !important;\n}\n.rootTable {\n  display: table;\n  width: 100%;\n}\n.tableCell {\n  display: table-cell;\n  vertical-align: middle;\n}\n.headerHeight {\n  height: 35px;\n}\n.displayInlineBlock {\n  display: inline-block;\n}\n.sessionLabel {\n  display: inline-block;\n  position: relative;\n  top: -9px;\n}\n.pos-modal {\n  border-radius: 0 !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/pages/pointofsale/styles/components/modal.less
// module id = 3110
// module chunks = 0